import { render } from "./GapiSettingView.vue?vue&type=template&id=f8d1c1aa"
import script from "./GapiSettingView.vue?vue&type=script&lang=js"
export * from "./GapiSettingView.vue?vue&type=script&lang=js"

import "./GapiSettingView.vue?vue&type=style&index=0&id=f8d1c1aa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__